/* eslint-env jest */
import { createdLocationFor } from './AccessCodeOnlyForm';

// #5192: /c/student_id_entry?from=parentsquare must reach Cart#created_location.
describe('createdLocationFor', () => {
  it('passes the URL from= through for a plain code', () => {
    expect(createdLocationFor('ABC123', 'parentsquare')).toBe('parentsquare');
  });

  it('is undefined with neither prefix nor from= (no needless cart save)', () => {
    expect(createdLocationFor('ABC123', undefined)).toBeUndefined();
    expect(createdLocationFor('', '')).toBeUndefined();
  });

  it('lets a printed-code prefix win over from=', () => {
    expect(createdLocationFor('s-ABC123', 'parentsquare')).toBe('sitting_cards');
    expect(createdLocationFor('P-ABC123', 'parentsquare')).toBe('proofs');
  });
});
